export default "https://skrwd-shindan.herokuapp.com/packs/media/images/support_illust_06-4f07135e6794095f92d07593fbd4db4d.png";